import api from 'api'
import { z } from 'zod'

export const supplementBRequestSchema = z
  .object({
    isRehire: z.boolean().default(false),
    isReverification: z.boolean().default(false),
    rehireDate: z.string().optional(),
    rehireNewLastName: z.string().optional(),
    rehireNewFirstName: z.string().optional(),
    rehireNewMiddleInitial: z.string().optional(),
    reverifyDocumentTitle: z.string().optional(),
    reverifyDocumentNumber: z.string().optional(),
    reverifyDocumentExpirationDate: z.string().optional(),
    reverifyUserDocumentId: z.number().optional(),
    reverifyAuthRepName: z.string().optional(),
    reverifySignedDate: z.string().optional(),
    pdfFile: z.instanceof(File, {
      message: 'Please upload the signed Supplement B document',
    }),
  })
  .refine((data) => data.isRehire || data.isReverification, {
    message: 'Select at least one: Rehire or Reverification',
    path: ['isRehire'],
  })

export type SupplementBRequest = z.infer<typeof supplementBRequestSchema>

export function submitSupplementBEntry(
  userId: string,
  payload: SupplementBRequest
) {
  const { pdfFile, ...rest } = supplementBRequestSchema.parse(payload)
  const formData = new FormData()

  formData.append(
    'data',
    JSON.stringify({
      is_rehire: rest.isRehire,
      is_reverification: rest.isReverification,
      rehire_date: rest.rehireDate || undefined,
      rehire_new_first_name: rest.rehireNewFirstName || undefined,
      rehire_new_last_name: rest.rehireNewLastName || undefined,
      rehire_new_middle_initial: rest.rehireNewMiddleInitial || undefined,
      reverify_document_title: rest.reverifyDocumentTitle || undefined,
      reverify_document_number: rest.reverifyDocumentNumber || undefined,
      reverify_document_expiration_date:
        rest.reverifyDocumentExpirationDate || undefined,
      reverify_user_document_id: rest.reverifyUserDocumentId ?? undefined,
      reverify_auth_rep_name: rest.reverifyAuthRepName || undefined,
      reverify_signed_date: rest.reverifySignedDate || undefined,
    })
  )

  formData.append('pdf_file', pdfFile)

  return api.post(`/admin/i9/supplement_b_entry/${userId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
